import {isEmptyOrNull} from "../../common/NamaCommon";

export function calcDisplayString(text) {
    if (!text || headerApproval(text))
        return "";
    let list = calcIndices(text);
    if (isEmptyOrNull(list))
        return "";
    let
        ret = "" + list.get(0);
    for (let i = 1;
         i < list.size();
         i++
    ) {
        ret += "," + list.get(i);
    }
    return ret;
}

function calcIndices(text)
{
    let integers = [];
    if (!text || headerApproval(text))
        return integers;
    let newText = "";
    for (let i = 0; i < text.length(); i++)
    {
        if (isNaN(parseInt(text.charAt(i), 10)))
            newText.append(',');
        else
            newText.append(text.charAt(i));
    }
    text = newText+"";
    let split = text.split(",");
    if (!split)
        return integers;
    for (let num of split)
    {
        if (isEmptyOrNull(num))
            continue;
        integers.push(parseInt(num));
    }
    return integers;
}

function headerApproval(text) {
    return text === "-1";
}